export { default as BG_BASEBALL_URL } from "./bg-baseball_md.jpg";
export { default as BG_BASKETBALL_URL } from "./bg-basketball_md.jpg";
export { default as BG_FOOTBALL_URL } from "./bg-football_md.jpg";
export { default as BG_HOCKEY_URL } from "./bg-hockey_md.jpg";
export { default as BG_SOCCER_URL } from "./bg-soccer_md.jpg";

export const BG_BASEBALL_PLACEHOLDER = "YmctYmFzZWJhbGxfdGh1bWIuanBnCg==";
export const BG_BASKETBALL_PLACEHOLDER = "YmctYmFza2V0YmFsbF90aHVtYi5qcGcK";
export const BG_FOOTBALL_PLACEHLDER = "YmctZm9vdGJhbGxfdGh1bWIuanBnCg==";
export const BG_HOCKEY_PLACEHOLDER = "YmctaG9ja2V5X3RodW1iLmpwZwo=";
export const BG_SOCCER_PLACEHOLDER = "Ymctc29jY2VyX3RodW1iLmpwZwo=";
